import { uploadCustomBackground } from '@/api/customBackground';

export default {
  namespaced: true,
  state: {
    customBackground: null
  },
  mutations: {
    SET_CUSTOM_BACKGROUND(background) {
      this.state.customBackground = background;
    }
  },
  actions: {
    async uploadCustomBackgroundAction({ commit }, data) {
      try {
        const response = uploadCustomBackground(data);
      
        commit('SET_CUSTOM_BACKGROUND', response);
        return response;
      } catch (error) {
        console.log(error)
      }
    }
  }
}